import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DEFAULT_LINE_STRING_COLOR, DEFAULT_LINE_STRING_STROKE_WIDTH } from '../../constants/styles';
export var YLineString = /*#__PURE__*/function () {
  function YLineString(options) {
    _classCallCheck(this, YLineString);
    _defineProperty(this, "options", void 0);
    this.options = options;
  }

  /** Возвращает объект настроек геообъекта в формате яндекса */
  return _createClass(YLineString, [{
    key: "getOptions",
    value: function getOptions() {
      var _this$options = this.options,
        coordinates = _this$options.coordinates,
        id = _this$options.id,
        name = _this$options.name;
      var options = this.getInternalOptions();
      return {
        id: id,
        geometry: {
          coordinates: coordinates,
          type: 'LineString'
        },
        type: 'Feature',
        properties: {
          name: name,
          options: this.options
        },
        options: _objectSpread({}, options)
      };
    }

    /** Возвращает поле опций для объекта настроек геообъекта в формате яндекса */
  }, {
    key: "getInternalOptions",
    value: function getInternalOptions() {
      var _this$options2 = this.options,
        _this$options2$stroke = _this$options2.strokeColor,
        strokeColor = _this$options2$stroke === void 0 ? DEFAULT_LINE_STRING_COLOR : _this$options2$stroke,
        _this$options2$stroke2 = _this$options2.strokeWidth,
        strokeWidth = _this$options2$stroke2 === void 0 ? DEFAULT_LINE_STRING_STROKE_WIDTH : _this$options2$stroke2,
        _this$options2$zIndex = _this$options2.zIndex,
        zIndex = _this$options2$zIndex === void 0 ? 701 : _this$options2$zIndex;
      return {
        strokeWidth: strokeWidth,
        strokeColor: strokeColor,
        zIndex: zIndex
      };
    }
  }]);
}();